import "../css/App.css";
import Feed from "./Feed";
import Header from "./Header";
import Login from "./Login";
import Sidebar from "./Sidebar";
import Widget from "./Widget";
import { useEffect } from "react";
import { auth } from "../firebase";
import { useStateValue } from "../StateProvider";
import { actionTypes } from "../Reducer";
import BottomNav from "./BottomNav";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Profile from "./Profile/Profile";
// import Setting from "./Setting/Setting";
import db from "../firebase";
import StoryReel from "./StoryReel";
import MessageSender from "./MessageSender";

function App() {
  const [state, dispatch] = useStateValue();
  const [{ user }] = useStateValue();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      dispatch({
        type: actionTypes.SET_USER,
        user: user,
      });

      //   console.log(user.uid);

      var userRef = db.collection("users").doc(user.uid);
      userRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            // console.log("Document data:", doc.data());
            dispatch({
              type: actionTypes.SET_USER_PROFILE,
              userProfile: doc.data(),
            });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    });
  }, [dispatch]);

  return (
    <div className="app">
      {!user ? (
        <Login />
      ) : (
        <>
          <Router>
            <Header />

            <Switch>
              <Route exact path="/">
                <div className="app__body">
                  <Sidebar />
                  <div className="app__mainCol">
                    <StoryReel />
                    <MessageSender />
                    <Feed />
                  </div>

                  <Widget />
                </div>
              </Route>
              <Route path="/profile/:username">
                <Profile />
              </Route>
              {/* <Route path="/setting/">
                <Setting />
              </Route> */}
            </Switch>

            <BottomNav />
          </Router>
        </>
      )}
    </div>
  );
}

export default App;
